import React, { useState } from 'react';
import '../styles/success.css';
import { register } from '../api/inventory'; // Assuming 'register' is a function to handle API call for creating an account

const SuccessComponent = ({customer_info, transactionId, totalPrice}) => {
    const [showSignUp, setShowSignUp] = useState(false);

    return (
        <div id="success">
            <h1>Checkout successful!</h1>
            <h1>PAYID: billnguyen16@gmail.com</h1>
            <h1>${totalPrice}</h1>
            <h1>Description (for PAYID): Order #{transactionId}</h1>
            <button id='pay-button' onClick={() => window.location.reload()}>Back to Main Menu</button>
        </div>
    );
}

export default SuccessComponent;